//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import {
  IFacebookPageFeedPostConfig,
  IInstagramFeedAutomaticPostConfig,
  IInstagramFeedManualPostConfig,
  IInstagramReelsAutomaticPostConfig,
  IInstagramReelsManualPostConfig,
  IInstagramStoryGroupAutomaticPostConfig,
  IInstagramStoryGroupPostConfig,
  IOrganicPinConfig,
  ITikTokVideoAutomaticPostConfig,
  ITwitterMediaPostConfig,
  IYouTubeAutomaticPostConfig,
  TScheduledPostConfig,
  TikTokPhotoAutomaticPostConfig,
  UniversalScheduledPostConfigType,
} from '@apis/universal-posts/config/universalScheduledPostConfigModel';

export const isScheduledOrganicPinConfig = (
  config: TScheduledPostConfig,
): config is IOrganicPinConfig => {
  return (
    config['@type'] === UniversalScheduledPostConfigType.PinterestOrganicPin
  );
};

export const isFacebookPageFeedPostConfig = (
  config: TScheduledPostConfig,
): config is IFacebookPageFeedPostConfig => {
  return (
    config['@type'] ===
      UniversalScheduledPostConfigType.FacebookPageFeedPhotoPost ||
    config['@type'] ===
      UniversalScheduledPostConfigType.FacebookPageFeedLinkPost ||
    config['@type'] ===
      UniversalScheduledPostConfigType.FacebookPageFeedVideoPost
  );
};

export const isInstagramFeedAutomaticPostConfig = (
  config: TScheduledPostConfig,
): config is IInstagramFeedAutomaticPostConfig => {
  return (
    config['@type'] ===
    UniversalScheduledPostConfigType.InstagramFeedAutomaticPost
  );
};

export const isInstagramFeedManualPostConfig = (
  config: TScheduledPostConfig,
): config is IInstagramFeedManualPostConfig => {
  return (
    config['@type'] === UniversalScheduledPostConfigType.InstagramFeedManualPost
  );
};

export const isInstagramReelsAutomaticPostConfig = (
  config: TScheduledPostConfig,
): config is IInstagramReelsAutomaticPostConfig => {
  return (
    config['@type'] ===
    UniversalScheduledPostConfigType.InstagramReelsAutomaticPost
  );
};

export const isInstagramReelsManualPostConfig = (
  config: TScheduledPostConfig,
): config is IInstagramReelsManualPostConfig => {
  return (
    config['@type'] ===
    UniversalScheduledPostConfigType.InstagramReelsManualPost
  );
};

export const isInstagramStoryGroupAutomaticPostConfig = (
  config: TScheduledPostConfig,
): config is IInstagramStoryGroupAutomaticPostConfig => {
  return (
    config['@type'] ===
    UniversalScheduledPostConfigType.InstagramStoryGroupAutomaticPost
  );
};

export const isInstagramStoryGroupPostConfig = (
  config: TScheduledPostConfig,
): config is IInstagramStoryGroupPostConfig => {
  return (
    config['@type'] === UniversalScheduledPostConfigType.InstagramStoryGroup
  );
};

export const isTikTokPhotoAutomaticPostConfig = (
  config: TScheduledPostConfig,
): config is TikTokPhotoAutomaticPostConfig => {
  return (
    config['@type'] ===
    UniversalScheduledPostConfigType.TikTokPhotoAutomaticPost
  );
};

export const isTikTokVideoAutomaticPostConfig = (
  config: TScheduledPostConfig,
): config is ITikTokVideoAutomaticPostConfig => {
  return (
    config['@type'] ===
    UniversalScheduledPostConfigType.TikTokVideoAutomaticPost
  );
};

export const isTikTokPostConfig = (config: TScheduledPostConfig) => {
  return (
    isTikTokPhotoAutomaticPostConfig(config) ||
    isTikTokVideoAutomaticPostConfig(config)
  );
};

export const isTwitterMediaPostConfig = (
  config: TScheduledPostConfig,
): config is ITwitterMediaPostConfig => {
  return config['@type'] === UniversalScheduledPostConfigType.TwitterMediaPost;
};

export const isYouTubeAutomaticPostConfig = (
  config: TScheduledPostConfig,
): config is IYouTubeAutomaticPostConfig => {
  return (
    config['@type'] === UniversalScheduledPostConfigType.YouTubeAutomaticPost
  );
};
